import Entity from '../../utilities/entity';

class TrainingCategory extends Entity {

}

export default new TrainingCategory();